import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Popover from 'modules/core/components/PopoverMenu'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onDelete: () => void
}

const TaxRatePopover = ({ onDelete }: Props) => {
  return (
    <Popover type="list">
      <Popover.Trigger>
        <Button.Decorative type="secondary" iconName="ellipsis" />
      </Popover.Trigger>
      <Popover.Content side="bottom" align="end">
        <PopoverMenu.TouchableOption onClick={onDelete} title={i18n.t('common.delete')} danger />
      </Popover.Content>
    </Popover>
  )
}

export default observer(TaxRatePopover)
